import authService, { INVITE_CODE_KEY } from '@/services/auth.service';
import { useSearchParams } from 'react-router-dom';

export default function useReceiveInviteCode() {
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get(INVITE_CODE_KEY);
  if (inviteCode) authService.setInviteCode(inviteCode);

  return { inviteCode: authService.getInviteCode() };
}
